import {
  AuthLayout,
  NewLayout,
  CenterLayout,
  SuspenseLayout,
} from "../layouts";
import { RouteLayout } from "../layouts/types";
import { lazy } from "react";
import {
  AnalyticsPage,
  BusinessPage,
  DevicesPage,
  DirectoryPage,
  ForgotPasswordPage,
  IntegrationsPage,
  LoginPage,
  LoginWithTokenPage,
  LogoutPage,
  ManageUsersPage,
  ResetPasswordPage,
  SettingsPage,
  TutorialsPage,
  UpgradePage,
} from "../pages";
import { PROFILE_TEMPLATE_PAGES, UPGRADE_PAGES } from "../constants/pages";

const ContactsPage = lazy(() =>
  import("../pages/contacts/ContactsPage").then(module => ({
    default: module.ContactsPage,
  })),
);

// Code-split this page; `pages/profileTemplates/index.ts` default-re-exports
// the component so the dynamic import resolves to `{ default }` directly.
const ProfileTemplatesPage = lazy(() => import("../pages/profileTemplates"));

const TemplateEditorPage = lazy(() =>
  import("../pages/profileTemplates/TemplateEditorPage").then(module => ({
    default: module.default,
  })),
);

export const routes: RouteLayout[] = [
  {
    path: "/manage-users",
    component: ManageUsersPage,
    layout: NewLayout,
  },
  {
    path: "/contacts",
    component: ContactsPage,
    layout: SuspenseLayout,
  },
  {
    path: "/analytics",
    component: AnalyticsPage,
    layout: NewLayout,
  },
  {
    path: "/directory",
    component: DirectoryPage,
    layout: NewLayout,
  },
  {
    path: "/settings",
    component: SettingsPage,
    layout: NewLayout,
  },
  {
    path: PROFILE_TEMPLATE_PAGES.LIST,
    component: ProfileTemplatesPage,
    layout: SuspenseLayout,
  },
  {
    path: PROFILE_TEMPLATE_PAGES.CREATE,
    component: TemplateEditorPage,
    layout: SuspenseLayout,
  },
  {
    path: PROFILE_TEMPLATE_PAGES.EDIT,
    component: TemplateEditorPage,
    layout: SuspenseLayout,
  },
  {
    path: "/business",
    component: BusinessPage,
    layout: NewLayout,
  },
  {
    path: "/integrations",
    component: IntegrationsPage,
    layout: NewLayout,
  },
  {
    path: "/manage-devices",
    component: DevicesPage,
    layout: NewLayout,
  },
  {
    path: "/tutorials",
    component: TutorialsPage,
    layout: NewLayout,
  },
  {
    path: "/auth/login",
    component: LoginPage,
    layout: CenterLayout,
  },
  {
    path: "/auth/forgot-password",
    component: ForgotPasswordPage,
    layout: AuthLayout,
  },
  {
    path: "/auth/reset-password",
    component: ResetPasswordPage,
    layout: AuthLayout,
  },
  {
    path: "/auth/logout",
    component: LogoutPage,
    layout: CenterLayout,
  },
  {
    path: "/auth/login-with-token",
    component: LoginWithTokenPage,
    layout: CenterLayout,
  },
  {
    path: UPGRADE_PAGES.SELECT_YOUR_PLAN,
    component: UpgradePage,
    layout: CenterLayout,
  },
];
